import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainContainerComponent } from './main-container.component';
import {MatButtonModule, MatIconModule, MatListModule, MatSidenavModule, MatToolbarModule, MatTooltipModule} from '@angular/material';
import {RouterModule} from '@angular/router';
import {MainContainerResolver} from '../../resolvers/main-container-resolver';

@NgModule({
  declarations:
  [
    MainContainerComponent
  ],
  exports:
  [
    MainContainerComponent
  ],
  imports:
  [
    CommonModule,
    MatSidenavModule,
    MatListModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ],
  providers:
  [
    MainContainerResolver
  ]
})
export class MainContainerModule
{

}
